import { render, staticRenderFns } from "./RenameRoleDialog.vue?vue&type=template&id=5bb5d04f&scoped=true"
import script from "./RenameRoleDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./RenameRoleDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RenameRoleDialog.vue?vue&type=style&index=0&id=5bb5d04f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb5d04f",
  null
  
)

export default component.exports